// extracted by mini-css-extract-plugin
export default {"Container":"Layout_Container__HIHX7"};